  <template lang="pug">
  .conversation-row(:class="{'row-selected': isRowSelected}", :selected="$route.params.case_id == case_id")
    b-form-row.align-items-center.flex-nowrap
      b-col(cols="auto", v-if="$can('read', 'list-bulk-edit')")
        b-form-checkbox(size="sm", :checked="isRowSelected", @change="checkboxChanged", :id="`${case_id}`")
      b-col.d-flex.align-items-center
        //info-icon.icon-sm.mr-2.text-info.hover-primary(v-b-toggle="`${case_id}`", @click.stop)
        span.text-truncate.text-help.text-sm(v-if="account_model") {{ account_model }}
      b-col(cols="auto")
        b-badge.fe-pulse(variant="success", v-if="!read && status !== 'close'") Nuevo mensaje
      b-col(cols="auto")
        b-badge.mb-1.mr-2(v-if="outbound", variant="info") Outbound
        CaseStatusBadge(:status="status")
    b-form-row.align-items-center.flex-nowrap
      b-col(cols="auto")
        Avatar(:platform="platform", size="xs", :src="User.profile_pic", @click="checkboxChanged")
      b-col.d-flex.flex-column
        .d-flex.align-items-center.flex-wrap.justify-content-between.text-sm.text-secondary
          b-link.text-help.delete-underlined(:to="buildNameParamsObject", @click="emitCaseId()") Caso {{ case_id }}
          b-link.text-help.delete-underlined(:to="buildNameParamsObject", @click="emitCaseId()") {{ updatedAt ? getLastDate : parsedTimeShort }}
        div.d-inline-flex.align-items-center.text-sm
          b-link.text-truncate(:to="buildNameParamsObject", @click="emitCaseId()") {{ userName.trim() || `Usuario ${User && User.external_id ? User.external_id.slice(-12) : "" }`}}      
          b-link.text-sm.d-inline-flex.text-help.delete-underlined.ml-2(:to="buildNameParamsObject", @click="emitCaseId()", v-if="isUserWithWhatsapp") {{ User.external_id }}
          b-img.ml-2(:to="buildNameParamsObject", @click="emitCaseId()", :src="verifiedImage", width="20", height="20", v-if="User.is_verified")
        .text-sm.text-truncate.text-secondary.mr-1(style="width: -webkit-fill-available;", :class="{'text-bold': !read}") {{ lastMessage.trim() || '' }}
    .d-flex.align-items-center.mt-1.flex-wrap
      .text-sm(v-if="getCaseAdminLength")
        b-badge.mb-1.mr-2(variant="light") {{ caseGroup.name }}
        span.mr-1 Asignado a: {{ caseAdmin.first_name }} {{ caseAdmin.last_name }}
    //b-collapse(:id="`${case_id}`", :visible="!!Tags.length")
    .d-flex.align-items-center.flex-wrap
      b-badge.mr-1.mb-1.opacity-50(
        v-for="(tag, index) in Tags",
        :key="index",
        :style="{'background-color': tag.color, color: BWTextColor(tag.color)}"
      ) {{ tag.name }}
</template>

<script>
import Avatar from './Avatar.vue'
import boxes from '../data/boxes'
import { BWTextColor } from '../helpers/contrast-color-generator'
import CaseStatusBadge from './CaseStatusBadge.vue'
import { createNamespacedHelpers } from 'vuex'
import { EventBus } from '../helpers/eventBus'

const accountController = createNamespacedHelpers('account')
const groupController = createNamespacedHelpers('group')

export default {
  data () {
    return {
      boxes,
      open_case: false,
      verifiedImage: "@/assets/verified.png"
    }
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    outbound: {
      type: Boolean,
      default: false
    },
    case_id: {
      type: Number,
      default: undefined
    },
    platform: {
      type: String,
      default: ''
    },
    User: {
      type: Object,
      default: function () {
        return {}
      }
    },
    Tags: {
      type: Array,
      default: function () {
        return []
      }
    },
    status: {
      type: String,
      default: ''
    },
    createdAt: {
      type: String,
      default: ''
    },
    updatedAt: {
      type: String,
      default: ''
    },
    checked: {
      type: null
    },
    admin_assigned_id: {
      type: Number,
      default: undefined
    },
    group_id: {
      type: Number,
      default: undefined
    },
    read: {
      type: Boolean,
      default: true
    },
    platform_model: {
      type: Object,
      default: () => {
        return {}
      }
    },
    last_message_preview: {
      type: String,
      default: ''
    },
    last_message_time: {
      type: String,
      default: ''
    },
    last_message_author: {
      type: String,
      default: ''
    },
  },
  computed: {
    ...groupController.mapState({
      groups: state => state.groups
    }),
    ...accountController.mapState({
      admins: state => state.admins
    }),
    ...accountController.mapGetters(['accountTimezone']),
    isRowSelected () {
      return Array.isArray(this.checked) ? (!!this.checked.filter(r => r.case_id == this.case_id).length) : this.checked
    },
    userName () {
      return Object.keys(this.User).length ? `${this.User.first_name || ''} ${this.User.last_name || ''}` : ''
    },
    lastMessage () {
      return typeof this.last_message_preview === 'string' ? this.last_message_preview : ''
    },
    momentTime () {
      const time = this.$moment(this.updatedAt)

      return time.isValid() ? time : this.$moment()
    },
    parsedTimeShort() {
      const time = {
        s: this.$moment().diff(this.momentTime, 'seconds'),
        m: this.$moment().diff(this.momentTime, 'minutes'),
        h: this.$moment().diff(this.momentTime, 'hours'),
        d: this.$moment().diff(this.momentTime, 'days'),
        mes: this.$moment().diff(this.momentTime, 'months'),
        año: this.$moment().diff(this.momentTime, 'years')
      }
      const priority = ['año', 'mes', 'd', 'h', 'm', 's']

      for (let i = 0; i < priority.length; i++) {
        if (time[priority[i]] > 0) {
          if (priority[i] === 'h' || priority[i] === 'm' || priority[i] === 's') {
            return this.momentTime.tz(this.accountTimezone).format('DD MMM hh:mm A')
          } else {
            return `${time[priority[i]]}${priority[i]}`
          }
        }
      }

      return ''
    },
    parsedTimeLong() {
      return this.momentTime.format('dddd, DD MMMM [de] YYYY, HH:mm A')
    },
    getLastDate() {
      if (this.accountTimezone && this.last_message_time) {
        return this.$moment(this.last_message_time)
          .tz(this.accountTimezone)
          .format('DD MMM hh:mm A')
      } else {
        return this.$moment(this.updatedAt)
          .tz(this.accountTimezone)
          .format('DD MMM hh:mm A')
      }

      return
    },
    caseGroup () {
      if (this.group_id != undefined) {
        const group = this.groups.find(group => group.group_id == this.group_id)

        if (group) return group
      }

      return {}
    },
    caseAdmin () {
      if (this.admin_assigned_id != undefined) {
        const admin = this.admins.find(admin => admin.admin_id == this.admin_assigned_id)

        if (admin) return admin
      }

      return {}
    },
    account_model () {
      if (!this.platform_model) return null
      if (this.platform_model.phone_number && this.platform_model.phone_number.length >= 5) {
        return this.platform_model.phone_number
      }

      return this.platform_model.name || null
    },
    buildNameParamsObject() {
      return { name: 'Case', params: { case_id: this.case_id } }
    },
    isUserWithWhatsapp() {
      return this.User.platform && this.User.platform.includes('whatsapp') && this.User.external_id
    },
    getCaseAdminLength() {
      return Object.keys(this.caseAdmin).length
    },
  },
  methods: {
    checkboxChanged() {
      const index = this.checked.findIndex(check => check.case_id == this.case_id)

      if (index >= 0) return this.checked.splice(index, 1)

      this.checked.push({
        case_id: this.case_id,
        platform: this.platform,
      })
    },
    emitCaseId() {
      return this.$emit('click', this.case_id)
    },
    BWTextColor
  },
  mounted() {
    EventBus.$on('isCalling', (value) => { this.isCalling = value })
  },
  components: { Avatar, CaseStatusBadge }
}
</script>

<style lang="scss" scoped>
  .conversation-row {
    width: 100%;
    padding: 0.5rem;
    transition: 0.5s;
    border-right: 2px solid transparent;

    &:not(:first-child) {
      border-top: 1px solid #edf2f9;
    }

    &[selected] {
      border-right: 2px solid #0e5ccf;
    }
  }

  .row-selected {
    background-color: rgba(14, 92, 207, 0.1);
  }

  .delete-underlined{
    text-decoration: none;
  }

  .delete-underlined:hover{
    color: #95aac9;
  }
</style>
